/**
 * Browser auto-open — the ONE decision for "the agent is browsing, show it".
 * The Computer pane is the one browser surface, so this opens it in every
 * world.
 *
 * Lives in its own module (same reasoning as browserFold.ts): both
 * streamingHandlers and browserStreamHandler need it, and the revisit hook
 * reuses the tool-name predicate.
 */
import { useComputerStore } from "../computerStore";

/** A live browser tool fire — the signal that the agent is browsing. */
export function isBrowserToolName(toolName: string): boolean {
  return (
    toolName.startsWith("computer_") ||
    toolName.startsWith("mcp__browser-control__")
  );
}

/**
 * Open the Computer panel on the Browser tab for this task. Respects the
 * user's sticky per-task close via onAgentBrowserActivity's own
 * hasUserClosed gate.
 */
export function openComputerOnBrowserActivity(taskId: string): void {
  useComputerStore.getState().onAgentBrowserActivity(taskId);
}

/**
 * Open the Computer panel on the Apps tab when a task's app announces
 * (task:preview_ready).
 */
export function openComputerOnAppAnnounced(taskId: string): void {
  useComputerStore.getState().onAppAnnounced(taskId);
}
